<template>
  <div>
    <h2 class="content-block">Simpeg Pegawai Import</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <input type="file" @change="onChange" />
        <xlsx-read :file="file">
          <xlsx-json>
            <template #default="{ collection }">
              <div>
                {{ collection }}
              </div>
            </template>
          </xlsx-json>
        </xlsx-read>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import { XlsxRead, XlsxJson } from "vue3-xlsx/dist/vue3-xlsx.cjs.prod.js";

export default {
  components: {
    XlsxRead,
    XlsxJson,
  },
  data() {
    return {
      file: null,
      data: [],
      tempData: null,
      collection: null,
    };
  },
  methods: {
    onChange(event) {
      console.log(event);
      this.file = event.target.files ? event.target.files[0] : null;
      console.log(this.file);

      // const file = event.target.files[0];
      // const rows = await readXlsxFile(file);
      // this.data = rows;
    },
    getData(c) {
      this.tempData = c;
      console.log(c);
      return c;
    },
  },
};
</script>
